/**
 * Created by Patrick on 7/5/2019.
 */

import React, { Component } from "react";
import moment from "moment";
import LoadingSpinner from "../components/LoadingSpinner";
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound'

class ClustersList extends Component {
  headers = [
    {
      key: "name",
      name: "Name",
      width: 3
    },
    {
      key: "numberDevices",
      name: "Device Count",
      width: 2
    },
    {
      key: "creationTime",
      name: "Age",
      width: 3
    },
    {
      key: "lastUpdate",
      name: "Last Update",
      width: 2
    },
    {
      key: "edit",
      name: "Edit",
      sortable: false,
      width: 1
    },
    {
      key: "delete",
      name: "Delete",
      sortable: false,
      width: 1
    }
  ]


  renderTableHeaders = () => {
    const { onSort, sortBy, isSortAsc } = this.props;
    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-top" title="Ascending" /> : <span className="glyphicon glyphicon-triangle-bottom" title="Descending"/>

    return this.headers.map(({ key, name, width, sortable }) => {
        if (sortable === false) {
            return (
                <th key={key}>
                    <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                </th>
            )
        }

        return (
            <th key={key}  onClick={() => onSort(key)}>
                <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                    {name} {sortBy === key && arrow }
                </div>
            </th>
        )
    })
  }

  renderTableRows = () => {
    const {
      clusters,
      selectedCluster,
      onClick,
      onEdit,
      onDelete
    } = this.props;

    if (clusters.length) {
      return clusters.map(cluster => {

        // Select what fields should be displayed in the row
        const selectedFields = {
          name: cluster.name,
          numberDevices: cluster.numberDevices,
          creationTime: moment(cluster.creationTime).fromNow().split(" ago")[0],
          lastUpdateTime: moment(cluster.lastUpdateTime).fromNow()   
        }
  
        return (
          <Row 
            key={cluster._id} 
            data={selectedFields}
            isActive={selectedCluster._id === cluster._id}
            onClick={() => onClick(cluster, false)}
            onEdit={() => onEdit(cluster._id)} 
            onDelete={() => onDelete(cluster._id)} 
          />
        );
      });
    }

    return <NoRecordsFound />
  }

  render() {
    const { isLoading } = this.props;

    return (
      <div className="test-instance-list">
        { isLoading ? <div className="flex-center"><LoadingSpinner /></div> : (
              <table className="table">
                <thead className="test-instance-details-head">
                  <tr>
                    { this.renderTableHeaders() }
                  </tr>
                </thead>
                <tbody>
                  { this.renderTableRows() }
                </tbody>
              </table>
        )}
      </div>
    ); // return
  } // render
} // ClustersList

export default ClustersList;
